import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const TabGroup = ({ defaultId, onChange, activeId, children, className, variant, name, ...rest }) => {
    const isControlled = activeId !== undefined;
    const idOfFirstTabChild = React.Children.map(children, (child) => { var _a; return (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id; })[0];
    const [selected, setSelected] = React.useState(isControlled ? activeId : defaultId || idOfFirstTabChild);
    React.useEffect(() => {
        if (isControlled)
            setSelected(activeId);
    }, [activeId]);
    const handleChange = e => {
        if (onChange)
            onChange(e);
        if (!isControlled)
            setSelected(e.target.id);
    };
    const getTabs = () => React.Children.map(children, (child) => {
        var _a, _b, _c, _d, _e;
        if (!child)
            return null;
        const tabProps = {
            name,
            key: `${name}-${(_a = child.props) === null || _a === void 0 ? void 0 : _a.id}`,
            onChange: handleChange,
            active: ((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.id) === selected,
            className: classNames(variant && variant.includes("toggle") ? "eds-tab--toggle" : "eds-tab", variant && variant.includes("small") && "eds-tab--toggle-small", variant && variant.includes("medium") && "eds-tab--toggle-medium", {
                "eds-tab--disabled": (_c = child.props) === null || _c === void 0 ? void 0 : _c.disabled,
                "eds-tab--active": (_d = child.props) === null || _d === void 0 ? void 0 : _d.active,
            }, (_e = child.props) === null || _e === void 0 ? void 0 : _e.className),
        };
        return React.cloneElement(child, tabProps);
    });
    return (_jsx("ul", { className: classNames(variant && variant.includes("toggle")
            ? "eds-tab-group--toggle"
            : "eds-tab-group", className), role: "tablist", ...rest, children: getTabs() }));
};
